import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const Login = () => {
  const [userlogin, setUserlogin] = useState("");
  const [userpass, setUserpass] = useState("");
  const [showSerieModal, setShowSerieModal] = useState(false);
  const [serieInput, setSerieInput] = useState("");
  const [serieError, setSerieError] = useState("");
  const [id_user_data, setId_user] = useState("");
  const [loading, setLoading] = useState(false); // Ajout du loader
  const [toast, setToast] = useState({ show: false, message: "", type: "info" });
  const navigation = useNavigate();

  // Fonction pour afficher un toast
  const showToast = (message, type = "info") => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: "", type: "info" });
    }, 4000);
  };

  // Vérifie la validité du numéro de série côté back (plus de liaison par utilisateur)
  const checkSerie = async (code_serie) => {
    try {
      const res = await fetch(`https://srv968119.hstgr.cloud/series/check/${code_serie}`);
      const data = await res.json();
      // On considère valide si l'API retourne success et des données
      return Boolean(data && data.success && data.data);
    } catch {
      return false;
    }
  };

  const handleSerieSubmit = async () => {
    setSerieError("");
    const isValid = await checkSerie(serieInput);
    if (isValid) {
      localStorage.setItem("numero_serie", serieInput);
      // Marque cette machine comme validée pour tous les enregistreurs
      localStorage.setItem("serie_validated", "true");
      setShowSerieModal(false);
      navigation("/home");
    } else {
      setSerieError("Numéro de série invalide ou non affecté à votre compte.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Démarre le loader
    try {
      const response = await fetch("https://srv968119.hstgr.cloud/users/connexion", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userlogin, userpass }),
        credentials: "same-origin",
        mode: "cors",
      });
      const data = await response.json();
      if (data.token) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("nom", data.user.nom);
        localStorage.setItem("statu", data.user.statu);
        localStorage.setItem("telephone", data.user.telephone);
        localStorage.setItem("id_user", data.user.id_user);
        localStorage.setItem("service", data.user.service);
        setId_user(data.user.id_user);

        if (data.user.statu === "controleur_police" || data.user.statu === "controleur_gendarmerie") {
          showToast("Compte restreint", "error");
          setLoading(false);
          return; // Empêche la navigation
        }

        if (data.user.statu === "enregistreur") {
          const serieValidated = localStorage.getItem("serie_validated") === "true";
          const numero_serie = localStorage.getItem("numero_serie");

          // Si déjà validé sur cette machine, pas de demande
          if (serieValidated && numero_serie) {
            navigation("/home");
          } else if (numero_serie) {
            // Tente une validation silencieuse du numéro déjà stocké
            const isValid = await checkSerie(numero_serie);
            if (isValid) {
              localStorage.setItem("serie_validated", "true");
              navigation("/home");
            } else {
              setShowSerieModal(true);
            }
          } else {
            setShowSerieModal(true);
          }
        } else {
          navigation("/home");
        }
      } else {
        showToast("Login incorrect !", "error");
      }
    } catch (error) {
      showToast("Verifier votre connexion !", "error");
      console.error("Login failed", error);
    }
    setLoading(false); // Arrête le loader
  };

  return (
    <div className="flex items-center justify-center content-center">
      <div className="bg-gray-100 bg-opacity-90 p-8 rounded-lg shadow-lg w-96">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-1">
          SNER
        </h2>
        <form onSubmit={handleSubmit} autoComplete="off">
          <div className="mb-4">
            <label htmlFor="email" className="block text-gray-700">
              Login
            </label>
            <input
              type="number"
              id="email"
              name="email"
              value={userlogin}
              onChange={(e) => setUserlogin(e.target.value)}
              className="w-full px-4 py-2 mt-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              autoComplete="off"
            />
          </div>
          <div className="mb-4">
            <label htmlFor="password" className="block text-gray-700">
              Mot de passe
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={userpass}
              onChange={(e) => setUserpass(e.target.value)}
              className="w-full px-4 py-2 mt-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              autoComplete="off"
            />
          </div>
          <button
            type="submit"
            className="w-full bg-gray-700 text-white py-2 rounded-lg hover:bg-blue-700 transition flex items-center justify-center"
            disabled={loading}
          >
            {loading ? (
              <svg className="animate-spin h-5 w-5 mr-2 text-white" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
              </svg>
            ) : null}
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>
      </div>
      {/* Modal pour numéro de série */}
      {showSerieModal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded-lg shadow-lg w-96 flex flex-col items-center">
            <h3 className="text-xl font-bold mb-4 text-gray-800">
              Numéro de série requis
            </h3>
            <input
              type="text"
              placeholder="Entrer le numéro de série"
              value={serieInput}
              onChange={(e) => setSerieInput(e.target.value)}
              className="w-full px-4 py-2 mb-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {serieError && (
              <div className="text-red-600 mb-2">{serieError}</div>
            )}
            <button
              className="bg-blue-700 text-white px-6 py-2 rounded-lg mt-2"
              onClick={async () => {
                await handleSerieSubmit();
              }}
            >
              Valider
            </button>
          </div>
        </div>
      )}

      {/* Toast Notification */}
      {toast.show && (
        <div className={`toast toast-top toast-end z-50`}>
          <div className={`alert ${
            toast.type === "success" ? "alert-success" : 
            toast.type === "error" ? "alert-error" : 
            "alert-info"
          }`}>
            <div>
              <span className="font-bold">
                {toast.type === "success" ? "✅" : 
                 toast.type === "error" ? "❌" : 
                 "ℹ️"}
              </span>
              <span>{toast.message}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
